<template>
    <v-flex>
        <v-layout row class="content-header">
            <v-flex md4 class="content-title">
            </v-flex>
            <v-flex md2>
                <v-select style="width:165px;" :full-width="false" :items="Periodos" item-text="Periodo" v-model="PeriodoSelecionado" item-value="Termo" label="Competência" @change="SelecionarPeriodo" outlined></v-select>
            </v-flex>
            <v-flex md4>
                <v-text-field v-model="termoPesquisa" label="Pesquisa" placeholder="Processo CNJ, CNPJ/CPF, Segurado..." outlined class="input-pesquisa"></v-text-field>
            </v-flex>
            <v-flex md2>
                &nbsp;&nbsp;<v-btn color="info" @click="pesquisar"><v-icon>mdi-magnify</v-icon></v-btn>
                &nbsp;<v-btn color="info" @click="BaixarLista()" title="Download Completo"><v-icon dark>mdi-cloud-download</v-icon></v-btn> 
            </v-flex>
            <!-- <v-layout row wrap class="text-right">
                <v-row class="text-right">
                    <v-col cols="4">
                        &nbsp;
                    </v-col>
                    <v-col cols="2">
                        <v-select :items="Periodos" item-text="Periodo" v-model="PeriodoSelecionado" item-value="Termo" label="Competência" @change="SelecionarPeriodo" outlined></v-select>                        
                    </v-col>                    
                    <v-col cols="4">
                        <v-text-field v-model="termoPesquisa" label="Pesquisa" placeholder="Número Processo CNJ, CNPJ/CPF Segurado..." outlined class="input-pesquisa"></v-text-field>                        
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="info" @click="pesquisar"><v-icon>mdi-magnify</v-icon></v-btn>
                        &nbsp;<v-btn color="info" @click="BaixarLista()" title="Download Completo"><v-icon dark>mdi-cloud-download</v-icon></v-btn> 
                    </v-col>                    
                </v-row>
                <br>
            </v-layout> -->
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
            <v-flex md12>
                <v-data-table
                    :headers="headers"
                    :items="processos"
                    :items-per-page="topItems"
                    :loading="loading"
                    :search="termoPesquisa"
                    loading-text="Carregando... Por favor aguarde."
                    no-data-text="Nenhuma informação encontrada"
                    no-results-text="Nenhuma informação encontrada"
                    :sort-by="['dataEncerramento']"
                    :sort-desc="[true]"                             
                    justify="center" style="max-height: 800px !important;">
                    <template v-slot:item.citacao="{ item }">
                        {{ FormatarData(item.citacao) }}
                    </template>
                    <template v-slot:item.valorTotal="{ item }">
                        {{ formatPrice(item.valorTotal) }}
                    </template>                    
                    <template v-slot:item.dataEncerramento="{ item }">
                        {{ FormatarData(item.dataEncerramento) }}
                    </template>                                         
                </v-data-table>                                       
            </v-flex>

            <v-overlay :value="fullLoading">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

        </v-layout>
    </v-flex>
</template>

<script>
    import Vue from 'vue'
    import { mapState, mapGetters } from 'vuex';
    import Helpers from "@/utilities/Helpers";
    import { constants } from 'fs';    

    export default {
        mixins: [Helpers],
        data() {
            return {
                baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
                loading: true,
                fullLoading: false,
                topItems: 10,
                totalItems: 1000,
                offset: 1,
                options: {},
                termoPesquisa: "",                 
                headers: [
                    {text: "Desconto", value: "desconto", sortable: true},
                    // {text: "Cod cor", value: "codigoCorretor", sortable: false},
                    {text: "Processo CNJ", value: "processoCnj", sortable: true},
                    {text: "Processo CNJ Sem Ponto", value: "processoCnjSemPonto", sortable: false, align: ' d-none'},
                    {text: "Segurado", value: "segurado", sortable: true},
                    {text: "CNPJ/CPF", value: "cnpjCpfSegurado", sortable: true},
                    {text: "CNPJ/CPF Segurado Sem Ponto", value: "cnpjCpfSeguradoSemPonto", sortable: false, align: ' d-none'},
                    {text: "Citação", value: "citacao", sortable: true},
                    {text: "Motivo da Ação", value: "motivoDaAcao", sortable: true},
                    {text: "Status", value: "status", sortable: true},
                    {text: "Total", value: "valorTotal", sortable: true},
                    {text: "Data Encerramento", value: "dataEncerramento", sortable: true},
                ],
                processos: [],
                PeriodoSelecionado : null,
                Periodos: [],

            }
        },
        methods:
        {
            CarregarPeriodo()
            {
                this.Periodos.push({ Id : 0, Periodo : "TODOS", Termo : null });
                for(let i = 0;i < 24;i++)
                {
                    const _hoje = new Date(); 
                    if (_hoje.getDate() == 31) 
                        _hoje.setDate(1);

                    const _data = new Date(_hoje.setMonth(_hoje.getMonth()-i));
                    _data.setHours(0, 0, 0);
                    _data.setMilliseconds(0); 

                    this.Periodos.push({ Id : i+1, Periodo : this.Meses[_data.getMonth()]+"/"+_data.getFullYear(), Termo : _data.getFullYear()+"-"+this.Meses[_data.getMonth()] });
                }
                this.PeriodoSelecionado = this.Periodos.find(obj => obj.Id == 1).Termo;
            },            
            CarregarProcessos()
            {
                this.loading = true;
                this.fullLoading = true;

                // let top = this.topItems;
                // let skip = (this.offset * top) - top;
                let codigoCorretor = this.usuario.codCorretor;
                //let url = "ProcessoJudicial/"+codigoCorretor+"/"+this.PeriodoSelecionado+"/"+top+"/"+skip;
                let url = "ProcessoJudicial/"+codigoCorretor+"/"+this.PeriodoSelecionado;

                if (this.termoPesquisa != "")
                    url += "/"+this.termoPesquisa.split("/").join("_");

                Vue.prototype.$httpPortal.get(url)
                .then(res => {
                    console.log(res.data);
                    this.processos = res.data;
                    for(let index in this.processos)
                    {
                        this.processos[index].processoCnjSemPonto = this.processos[index].processoCnj.split('.').join('').split('-').join('');
                        this.processos[index].cnpjCpfSeguradoSemPonto = this.processos[index].cnpjCpfSegurado.split('.').join('').split('-').join('');
                    }

                    this.totalItems = this.processos.length;
                    this.loading = false;                
                    this.fullLoading = false;
                })
                .catch(ex => {
                    console.log(ex);
                    this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                    this.loading = false;
                    this.fullLoading = false;
                });                
            },
            pesquisar(){
                    this.CarregarProcessos();        
            },
            BaixarLista()
            {
                let codigoCorretor = this.usuario.codCorretor;
                let url = this.baseURL + "Emissao/ProcessoJudicial/" + codigoCorretor;
                window.open(url, "_blank");             
            },
            SelecionarPeriodo(value)
            {
                this.PeriodoSelecionado = value;
                this.CarregarProcessos();
            },  
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },                                              
        },
        watch: {                    
        },        
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
        mounted(){
            this.CarregarPeriodo();            
            this.CarregarProcessos();
        },                
    }
</script>
